export enum StripeSubscriptionStatus {
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  TRIALING = 'trialing',
  ACTIVE = 'active',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  PAUSED = 'paused',
}

export interface StripeProductGeolocation {
  stripeProductId: string
  stripePriceId: string
  country: string
  trialPeriodDays: number
  isDefault: boolean
  paymentGateways: PaymentGateways[]
}

export enum PaymentGateways {
  ADYEN = 'adyen',
  STRIPE = 'stripe',
}
